import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './redux/store';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { appConfig } from './config/appConfig';
// import { CssVarsProvider, extendTheme } from "@mui/joy";


const root = ReactDOM.createRoot(document.getElementById('root'));

const appShell = (
  <Provider store={store}>
    <App />
  </Provider>
);

if (appConfig.googleLoginEnabled && !appConfig.googleClientId) {
  console.warn(
    '[Auth] Google login is enabled but REACT_APP_GOOGLE_CLIENT_ID is missing. Google login was disabled.'
  );
}

const appWithProviders = appConfig.isGoogleLoginConfigured
  ? (
    <GoogleOAuthProvider clientId={appConfig.googleClientId}>
      {appShell}
    </GoogleOAuthProvider>
  )
  : appShell;

root.render(<React.StrictMode>{appWithProviders}</React.StrictMode>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
